<template>
  <div>
    <q-form ref="editForm">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-card title="개정" class="cardClassDetailForm revisionLayout" topClass="topcolor-orange" v-if="popupParam.psiLocalVentilationId">
            <template slot="card-detail">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="row">
                  <div class="col-2">
                    <c-text
                      :required="editable && isRevision"
                      :editable="editable && isRevision"
                      label="개정번호"
                      name="revisionNum"
                      v-model="data.revisionNum">
                    </c-text>
                  </div>
                  <div class="col-2">
                    <c-text
                      :editable="false"
                      label="개정일시"
                      name="regDtStr"
                      v-model="data.regDtStr">
                    </c-text>
                  </div>
                  <div class="col-2">
                    <c-text
                      :editable="false"
                      label="개정자"
                      name="regUserName"
                      v-model="data.regUserName">
                    </c-text>
                  </div>
                  <!-- <div class="col-3">
                    <c-text
                      :afterIcon="editable ? [
                        { name: 'search', click: true, callbackName: 'searchMoc', color: 'teal' },
                        { name: 'close', click: true, callbackName: 'removeMoc', color: 'red' }
                      ] : null"
                      :editable="editable"
                      :disabled="true"
                      label="MOC번호"
                      name="sopMocId"
                      v-model="data.sopMocId"
                      @searchMoc="searchMoc"
                      @removeMoc="removeMoc" />
                  </div> -->
                  <div class="col-6">
                    <c-text
                      :required="editable && isRevision"
                      :editable="editable && isRevision"
                      label="개정사유"
                      name="revisionContent"
                      v-model="data.revisionContent">
                    </c-text>
                  </div>
                </div>
              </div>
            </template>
          </c-card>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-card title="환기장치(국소배기장치) 상세정보" class="cardClassDetailForm">
            <template slot="card-select">
              <c-select
                :editable="!isRevision"
                v-if="popupParam.psiLocalVentilationId"
                :comboItems="gridrev.data"
                type="custom"
                typetxt="개정이력"
                itemText="revisionNum"
                itemValue="psiLocalVentilationId"
                name="selectedpsiLocalVentilationId"
                label=""
                v-model="selectedpsiLocalVentilationId"
                @input="rowClickRev"
              ></c-select>
            </template>
            <template slot="card-button">
              <q-btn-group outline >
                <c-btn
                  v-show="editable && popupParam.psiLocalVentilationId && !isRevision"
                  label="개정"
                  icon="restart_alt"
                  @btnClicked="SetRevision" />
                <c-btn
                  v-show="editable && popupParam.psiLocalVentilationId && isRevision"
                  label="개정취소"
                  icon="restart_alt"
                  @btnClicked="CancelRevision" />
                <c-btn
                  v-if="editable && popupParam.psiLocalVentilationId"
                  label="삭제"
                  icon="remove"
                  @btnClicked="deleteData" />
                <c-btn
                  v-if="editable"
                  :url="saveUrl"
                  :isSubmit="isSave"
                  :param="data"
                  :mappingType="mappingType"
                  label="저장"
                  icon="save"
                  @beforeAction="saveData"
                  @btnCallback="saveCallback" />
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-6">
                <c-text
                  :required="true"
                  :editable="editable"
                  label="공정 또는 작업장명"
                  name="processName"
                  v-model="data.processName">
                </c-text>
              </div>
              <div class="col-3">
                <c-text
                  :required="true"
                  :editable="editable"
                  label="실내외구분"
                  name="inOutFlag"
                  v-model="data.inOutFlag">
                </c-text>
              </div>
              <div class="col-3">
                <c-plant
                  :required="true"
                  :editable="editable"
                  type="edit"
                  name="plantCd"
                  v-model="data.plantCd">
                </c-plant>
              </div>
              <div class="col-6">
                <c-text
                  :required="true"
                  :editable="editable"
                  label="발생원"
                  name="sourceName"
                  v-model="data.sourceName">
                </c-text>
              </div>
              <div class="col-6">
                <c-text
                  :editable="editable"
                  label="유해물질종류"
                  name="harmfulTypeCd"
                  v-model="data.harmfulTypeCd">
                </c-text>
              </div>
              <div class="col-4">
                <c-text
                  :editable="editable"
                  label="후드형식"
                  name="hoodForm"
                  v-model="data.hoodForm">
                </c-text>
              </div>
              <div class="col-4">
                <c-text
                  suffix="m/s"
                  :editable="editable"
                  label="후드의제어풍속(m/s)"
                  name="hoodVelocity"
                  v-model="data.hoodVelocity">
                </c-text>
              </div>
              <div class="col-4">
                <c-text
                  suffix="m/s"
                  :editable="editable"
                  label="덕트내반응속도(m/s)"
                  name="reactionVelocity"
                  v-model="data.reactionVelocity">
                </c-text>
              </div>
              <div class="col-4">
                <c-text
                  suffix="㎥/min"
                  :editable="editable"
                  label="배풍량(㎥/min)"
                  name="airVolume"
                  v-model="data.airVolume">
                </c-text>
              </div>
              <div class="col-4">
                <c-text
                  suffix="Kw"
                  :editable="editable"
                  label="전동기-용량(Kw)"
                  name="motorVolume"
                  v-model="data.motorVolume">
                </c-text>
              </div>
              <div class="col-4">
                <c-text
                  :editable="editable"
                  label="전동기-방폭형식"
                  name="motorExplosionForm"
                  v-model="data.motorExplosionForm">
                </c-text>
              </div>
              <div class="col-6">
                <c-textarea
                  :editable="editable"
                  :rows="3"
                  label="공기정화장치형식"
                  name="airCleanType"
                  v-model="data.airCleanType">
                </c-textarea>
              </div>
              <div class="col-6">
                <c-textarea
                  :editable="editable"
                  :rows="3"
                  label="배기 및 처리순서"
                  name="airExhaustOrder"
                  v-model="data.airExhaustOrder">
                </c-textarea>
              </div>
              <div class="col-6">
                <c-line
                  :editable="editable"
                  label="관련라인"
                  multiple="multiple"
                  name="processCd"
                  v-model="data.processCd">
                </c-line>
              </div>
              <div class="col-3">
                <c-text
                  :editable="editable"
                  label="관련장소"
                  name="location"
                  v-model="data.location">
                </c-text>
              </div>
              <div class="col-3">
                <c-dept
                  :isFirstValue="this.popupParam.psiLocalVentilationId ? false : true"
                  :editable="editable"
                  label="관리부서"
                  name="deptCd"
                  v-model="data.deptCd">
                </c-dept>
              </div>
            </template>
          </c-card>
        </div>
      </div>
      <c-dialog :param="popupOptions"></c-dialog>
    </q-form>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'local-ven-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        psiLocalVentilationId: '',
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      selectedpsiLocalVentilationId: null,
      saveUrl: transactionConfig.psi.lbe.localven.insert.url,
      mappingType: 'POST',
      insertUrl: '',
      updateUrl: '',
      deleteUrl: '',
      revlistUrl: '',
      editable: true,
      isSave: false,
      isdelete: false,
      isRevision: false,
      data: {
        psiLocalVentilationId: '',  // 국소배기장치 일련번호
        plantCd: '',  // 사업장코드
        processName: '',  // 공정또는작업장명
        inOutFlag: '',  // 실내외구분
        sourceName: '',  // 발생원
        harmfulTypeCd: '',  // 유해물질종류
        hoodForm: '',  // 후드형식
        hoodVelocity: '',  // 후드의제어풍속
        reactionVelocity: '',  // 덕트내반응속도
        airVolume: '',  // 배풍량
        motorVolume: '',  // 전동기용량
        motorExplosionForm: '',  // 전동기방폭형식
        airCleanType: '',  // 공기정화장치형식
        airExhaustOrder: '',  // 배기및처리순서
        processCd: '',
        deptCd: '',
        revisionNum: '',
        groupId: '',
        sysRevision: 1,
        revisionContent: '제정',
        regDtStr: '',
        regUserName: '',
        sopMocId: '',
        location: '',
      },
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        top: '10px',
        param: {},
        closeCallback: null,
      },
      gridrev: {
        columns: [
          {
            name: 'revisionNum',
            field: 'revisionNum',
            label: '개정번호',
            align: 'center',
            style: 'width: 80px',
            sortable: true,
          },
          {
            name: 'revisionContent',
            field: 'revisionContent',
            label: '개정사유',
            align: 'left',
            sortable: true,
          },
          {
            name: 'regDtStr',
            field: 'regDtStr',
            label: '개정일시',
            style: 'width: 150px',
            align: 'center',
            sortable: true,
          },
          {
            name: 'regUserName',
            field: 'regUserName',
            label: '개정자',
            align: 'center',
            style: 'width: 80px',
            sortable: true,
          },
        ],
        data: [],
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      // url setting
      this.detailUrl = selectConfig.psi.lbe.localven.get.url;
      this.insertUrl = transactionConfig.psi.lbe.localven.insert.url;
      this.updateUrl = transactionConfig.psi.lbe.localven.update.url;
      this.deleteUrl = transactionConfig.psi.lbe.localven.delete.url;
      this.revlistUrl = selectConfig.psi.lbe.localven.list.url + '/revs';
      this.getData();
    },
    getData() {
      this.isRevision = false;
      if (this.popupParam.psiLocalVentilationId) {
        this.getDetail(this.popupParam.psiLocalVentilationId, true);
        this.selectedpsiLocalVentilationId = this.popupParam.psiLocalVentilationId;
      }
    },
    getDetail(_psiLocalVentilationId, _check) {
      this.$http.url = this.$format(this.detailUrl, _psiLocalVentilationId);
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.data = _result.data;
        this.isRevision = false;
        if (_check) {
          this.getRevList(_result.data.groupId);
        }
        if(_result.data.psiLocalVentilationId == this.popupParam.psiLocalVentilationId) {
          this.editable = this.$route.meta.editable;
        } else {
          this.editable = false;
        }
      },);
    },
    saveData() {
      if (this.popupParam.psiLocalVentilationId) {
        this.saveUrl = this.updateUrl;
        this.mappingType = 'PUT';
      } else {
        this.saveUrl = this.insertUrl;
        this.mappingType = 'POST';
      }
      let saveMsg = '저장하시겠습니까?';
      if (this.isRevision) {
        saveMsg = '현재버전을 개정하여 저장하시겠습니까?';
      }
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: saveMsg,
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.data.regUserId = this.$store.getters.user.userId;
              this.data.chgUserId = this.$store.getters.user.userId;
              // 개정시
              if (this.isRevision) {
                this.saveUrl = this.insertUrl;
                this.mappingType = 'POST';
                this.data.sysRevision = parseInt(this.data.sysRevision) + 1;
              }
              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    deleteData() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.popupParam.psiLocalVentilationId);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            this.isdelete = !this.isdelete;
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.$emit('closePopup');
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    saveCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.popupParam.psiLocalVentilationId = result.data.psiLocalVentilationId
      this.getData();
    },
    SetRevision() {
      this.$http.url = selectConfig.com.revision.getversion;
      this.$http.param = {revisionNum: this.data.revisionNum}
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.data.revisionNum = _result.data;
        this.data.revisionContent = '';
        this.data.regDtStr = '';
        this.data.regUserName = '';
        this.data.sopMocId = '';
        this.isRevision = true;
      });
    },
    CancelRevision() {
      this.isRevision = false;
      this.getData();
    },
    getRevList(_groupId) {
      this.$http.url = this.revlistUrl;
      this.$http.type = 'GET';
      this.$http.param = {groupId: _groupId};
      this.$http.request((_result) => {
        this.gridrev.data = _result.data;
      },);
    },
    rowClickRev(row) {
      if (row) {
        if (row != this.data.psiLocalVentilationId) {
          this.selectedpsiLocalVentilationId = row;
          this.getDetail(this.selectedpsiLocalVentilationId, false);
        }
      }
    },
    searchMoc() {
      this.popupOptions.title = 'MOC 검색'; // MOC 검색
      this.popupOptions.param = {
        type: 'single'
      };
      this.popupOptions.target = () => import(`${'@/pages/sop/moc/mocPop.vue'}`);
      this.popupOptions.width = '60%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeMocPopup;
    },
    closeMocPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data) {
        this.data.sopMocId = data.chngNum
      }
    },
    removeMoc() {
      this.data.sopMocId = null
    },
  }
};
</script>
